import React from 'react'
import './LandingPage.css'
import BigHero from '../Sections/LandingPage/BigHero'
import { BrowserView, MobileView} from 'react-device-detect';
import MobBigHero from '../Sections/LandingPage/Mobile/MobBigHero';
import Solution from '../Sections/LandingPage/Solution';
import MobSolution from '../Sections/LandingPage/Mobile/MobSolution';
import Partner from '../Sections/LandingPage/Partner';
import MobPartner from '../Sections/LandingPage/Mobile/MobPartner';
import Deal from '../Sections/LandingPage/Deal';
import MobDeal from '../Sections/LandingPage/Mobile/MobDeal';
import Footer from '../Sections/LandingPage/Footer';
import MobFooter from '../Sections/LandingPage/Mobile/MobFooter';

function LandingPage() {
    return (
        <div id='landingpage'>
            <BrowserView>
                <BigHero/>
                <Solution/>
                <Partner/>
                <Deal/>
                <Footer/>
            </BrowserView>
            <MobileView>
                <MobBigHero/>
                <MobSolution/>
                <MobPartner/>
                <MobDeal/>
                <MobFooter/>
            </MobileView>
        </div>
    )
}

export default LandingPage
